<template>
  <b-card title="Check Logs">
    <b-row class="mb-3" cols="1" cols-md="2" cols-lg="3">
      <b-col class="mb-2">
        <b-form-select
          v-model="filters.level"
          :options="levelOptions"
          @change="fetchLogs"
          placeholder="Select Level"
        />
      </b-col>
      <b-col class="mb-2">
        <b-form-input
          v-model="filters.message"
          placeholder="Search by Message"
          @input="debouncedFetchLogs"
        />
      </b-col>
      <b-col class="mb-2">
        <b-form-input
          v-model="filters.transactionID"
          placeholder="Search by Transaction ID"
          @input="debouncedFetchLogs"
        />
      </b-col>
      <b-col class="mb-2">
        <b-form-input
          v-model="filters.service"
          placeholder="Search by Service"
          @input="debouncedFetchLogs"
        />
      </b-col>
      <b-col class="mb-2">
        <b-form-input
          v-model="filters.search"
          placeholder="General Search (Meta)"
          @input="debouncedFetchLogs"
        />
      </b-col>
      <b-col class="mb-2">
        <b-form-datepicker
          v-model="filters.timestamp"
          placeholder="Filter by Date"
          @input="fetchLogs"
          class="w-100"
        ></b-form-datepicker>
      </b-col>
      <b-col cols="12" class="mb-2">
        <b-button variant="outline-danger" @click="clearFilters" block>
          Clear Filters
        </b-button>
      </b-col>
    </b-row>
    <div class="table-responsive-scroll">
      <b-table
        :items="logs"
        :fields="fields"
        responsive
        striped
        hover
        small
        class="mb-3"
      >
        <template #cell(meta)="data">
          <div v-if="data.item.meta && typeof data.item.meta === 'object'">
            <div
              v-for="(val, key) in data.item.meta"
              :key="key"
              v-b-tooltip.hover
              :title="formatMetaValue(val)"
              class="text-truncate"
              style="max-width: 200px;"
            >
              <strong>{{ key }}:</strong>
              {{ truncateValue(val, 30) }}
            </div>
          </div>
        </template>
        <template #cell(timestamp)="row">
          {{ formatDate(row.item.timestamp) }}
        </template>
      </b-table>
    </div>

    <b-pagination
      v-model="currentPage"
      :total-rows="totalLogs"
      :per-page="entryLimit"
      align="center"
      @input="fetchLogs"
    />
  </b-card>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BPagination,
  BFormSelect,
} from 'bootstrap-vue';
import { mapActions, mapState } from 'vuex';
import debounce from 'lodash/debounce';

export default {
  name: 'LogViewer',
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BPagination,
    BFormSelect,
  },
  data() {
    return {
      filters: {
        level: '',
        message: '',
        transactionID: '',
        service: '',
        search: '',
        timestamp: null,
      },
      levelOptions: [
        { value: '', text: 'All Levels' },
        { value: 'info', text: 'Info' },
        { value: 'error', text: 'Error' },
        { value: 'warn', text: 'Warn' },
        { value: 'debug', text: 'Debug' },
      ],
      currentPage: 1,
      entryLimit: 10,
      fields: [
        { key: 'timestamp', label: 'Timestamp' },
        { key: 'level', label: 'Level' },
        { key: 'message', label: 'Message' },
        { key: 'transactionID', label: 'Transaction ID' },
        { key: 'service', label: 'Service' },
        { key: 'meta', label: 'Meta Info' }
      ],
    };
  },
  computed: {
    ...mapState('logs', ['logs', 'totalLogs']),
  },
  watch: {
    currentPage() {
      this.fetchLogs();
    },
  },
  created() {
    this.debouncedFetchLogs = debounce(this.fetchLogs, 500);
  },
  mounted() {
    this.fetchLogs();
  },
  methods: {
    ...mapActions('logs', ['getLogs']),
    fetchLogs() {
      console.log(this.filters);
      
      const params = {
        ...this.filters,
        timestamp: this.filters.timestamp
          ? new Date(this.filters.timestamp).toISOString().split('T')[0]
          : undefined,
        page: this.currentPage,
        entry: this.entryLimit,
      };
      console.log('Fetching logs with params:', params);
      
      this.getLogs(params);
    },
    clearFilters() {
      this.filters = {
        level: '',
        message: '',
        transactionID: '',
        service: '',
        search: '',
        timestamp: null,
      };
      this.currentPage = 1;
      this.fetchLogs();
    },
    formatDate(iso) {
      if (!iso) return '-';
      const date = new Date(iso);
      return date.toLocaleString();
    },
    formatMetaValue(val) {
      return typeof val === 'object' ? JSON.stringify(val) : val;
    },
    truncateValue(val, length = 30) {
      const raw = typeof val === 'object' ? JSON.stringify(val) : String(val);
      return raw.length > length ? raw.slice(0, length) + '…' : raw;
    }
  },
};
</script>


<style scoped>
.table-responsive-scroll {
  overflow-x: auto;
  width: 100%;
}
.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
/* Tambahan styling jika diperlukan */
</style>
